import { render, staticRenderFns } from "./CommercialBreak.vue?vue&type=template&id=6ad25ffd"
import script from "./CommercialBreak.vue?vue&type=script&lang=js"
export * from "./CommercialBreak.vue?vue&type=script&lang=js"
import style0 from "./CommercialBreak.vue?vue&type=style&index=0&id=6ad25ffd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports